<template>

    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow
                        v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  
                        class="pb-3" 
                    >
                        <CCol sm="12">
                            <CButton
                                color="primary"
                                @click="addCategory">Добавить</CButton>
                        </CCol>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <draggable v-model="categories" tag="tbody">
                                <tr v-for="category in categories" :key="category.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ category.title }}</td>
                                    <td v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  >
                                        <CButton @click="editCategory(category.id)"><CIcon :content="$options.icons.cilPencil" class="handle" /></CButton>
                                        <CButton @click="removeCategory(category.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)">
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить порядок</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <RestaurantCategoryUpsertDialog
            ref="upsertDialog"
            :category-id="selectedCategory"
            :categories="categories"
            @success="fetch"
        />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить категорию? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import RestaurantCategoryUpsertDialog from '@/components/RestaurantCategoryUpsertDialog';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        name: 'RestaurantCategories',

        components: {
            RestaurantsTabLinks,
            draggable,
            RestaurantCategoryUpsertDialog,
            AppConfirmDialog
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil
        },

        data() {
            return {
                restaurant: {
                    title: '',
                    description: '',
                    picture: '',
                    open_at: '',
                    close_at: '',
                    min_price: 0,
                    phone: '',
                    delivery_time: 0,
                    enabled: true,
                    position: 0,
                },
                removeCategories: [],
                categories: [],
                selectedCategory: null,
            };
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                Vue.axios
                    .get('/restaurants/' + id)
                    .then(resp => {
                        this.restaurant = resp.data;
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                Vue.axios
                    .get(`/restaurants/${id}/categories`)
                    .then(resp => {
                        this.categories = resp.data.map(item => {
                            item.enabled = Boolean(item.enabled);
                            item.empty = Boolean(item.empty);
                            return item;
                        });
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            save() {
                const categoriesToSave = [];
                let index = 0;
                this.categories.forEach(category => {
                    categoriesToSave.push({
                        id: category.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post(`/restaurants/${this.$route.params.id}/categories/reorder`, {
                        reorder: categoriesToSave,
                    })
                    .then(resp => {
                        this.$root.$emit('showAlert', 'Порядок успешно сохранен.');
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            addCategoryOption(id) {
                let contains = false;
                for (var i = 0; i < this.categories.length; i++) {
                    if (this.categories[i].id === id) {
                        contains = true;
                    }
                }
                return !contains;
            },

            addCategory() {
                this.selectedCategory = null;
                this.$refs.upsertDialog.open();
            },

            editCategory(category) {
                this.selectedCategory = category;
                this.$refs.upsertDialog.open();
            },

            removeCategory(category) {
                this.selectedCategory = category;
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.selectedCategory) {
                    return false;
                }
                try {
                    await Vue.axios.delete(`/restaurants/${this.$route.params.id}/categories/${this.selectedCategory}`);
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка удаления категории. ' + err);
                }
                await this.fetch();
            },

            goBack() {
                this.$router.push({
                    path: '/restaurants/' + this.$route.params.id,
                });
            },
        },
    };
</script>
<style scoped>
.handle {
    cursor: pointer;
}
</style>
